module.exports = __webpack_public_path__ + "img/party_popper.9a48c9b9.gif";